import { toast } from 'react-toastify';
import { FcToast, FcToastData } from '../FcToast';

const displayToast = (data: FcToastData) => toast(FcToast, { data, closeButton: false, hideProgressBar: true });

export const appToast = {
  info: (message: string) => displayToast({ message, type: 'info' }),
  warning: (message: string) => displayToast({ message, type: 'warning' }),
  error: (message: string) => displayToast({ message, type: 'alert' }),
};

export const displayLoadingToast = (data: FcToastData) => {
  const id = toast.loading(FcToast, {
    data,
    closeButton: false,
    hideProgressBar: true,
  });

  return {
    stop: () => toast.update(id, { render: 'Terminé', type: 'success', isLoading: false }),
  };
};